import { createAction, props } from '@ngrx/store';
import { Update } from '@ngrx/entity';

import { ContractClass } from './contract-class.model';

export const postContractClass = createAction(
  '[ContractClass/API] POST ContractClasses',
  props<{ ContractListID: string }>()
);

export const putContractClass = createAction(
  '[ContractClass/API] PUT ContractClasses',
  props<{ contractClasses: Array<ContractClass>}>()
);

export const loadContractClasses = createAction(
  '[ContractClass/API] Load ContractClasses',
  props<{ contractClasses: ContractClass[] }>()
);

export const addContractClass = createAction(
  '[ContractClass/API] Add ContractClass',
  props<{ contractClass: ContractClass }>()
);

export const upsertContractClass = createAction(
  '[ContractClass/API] Upsert ContractClass',
  props<{ contractClass: ContractClass }>()
);

export const addContractClasses = createAction(
  '[ContractClass/API] Add ContractClasses',
  props<{ contractClasses: ContractClass[] }>()
);

export const upsertContractClasses = createAction(
  '[ContractClass/API] Upsert ContractClasses',
  props<{ contractClasses: ContractClass[] }>()
);

export const updateContractClass = createAction(
  '[ContractClass/API] Update ContractClass',
  props<{ contractClass: Update<ContractClass> }>()
);

export const updateContractClasses = createAction(
  '[ContractClass/API] Update ContractClasses',
  props<{ contractClasses: Update<ContractClass>[] }>()
);

export const deleteContractClass = createAction(
  '[ContractClass/API] Delete ContractClass',
  props<{ id: string }>()
);

export const deleteContractClasses = createAction(
  '[ContractClass/API] Delete ContractClasses',
  props<{ ids: string[] }>()
);

export const clearContractClasss = createAction(
  '[ContractClass/API] Clear ContractClasss'
);
